import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { swtichAndRedirectUser } from 'app/store/actions/auth.action';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthState } from '../../store/reducers/auth.reducer';

@Injectable({ providedIn: 'root' })
export class RedirectGuard {
  /**
   *
   * @param {Router} _router
   * @param store
   */
  constructor(
    private _router: Router,
    private store: Store
  ) { }
  waitForDataToLoad(): Observable<AuthState> {
    return this.store.select((state: { auth: AuthState }) => state.auth);
  }
  // canActivate
  async canActivate(route: ActivatedRouteSnapshot) {
    if (Object.prototype.hasOwnProperty.call(route.queryParams, 'token')) {
      //TODO: UPDATE DATA end_user: false, isThirdPartyLogin: false
      const key = route?.data?.['key'] ?? null;
      this.store.dispatch(swtichAndRedirectUser({ token: decodeURIComponent(route.queryParams.token), key: key }));
      return this.waitForDataToLoad().pipe(map(() => { return true; }));
    } else {
      return this._router.navigate(['login']);
    }
  }


}
